// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".twitter-post-preview-footer[data-v-4e349f50]{padding-top:5px;color:#395996;display:flex;margin-right:20px}.twitter-post-preview-footer__action[data-v-4e349f50]{display:flex;align-items:center;gap:5px;margin-right:40px;transform:scale(.7)}", ""]);
// Exports
module.exports = exports;
